import React, { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api/api';

export default function BookingRequest() {
    const [searchParams] = useSearchParams();
    const prospectId = searchParams.get('prospectId');
    const defaultName = searchParams.get('name') || '';
    const defaultEmail = searchParams.get('email') || '';

    const [name, setName] = useState(defaultName);
    const [email, setEmail] = useState(defaultEmail);
    const [slot1, setSlot1] = useState('');
    const [slot2, setSlot2] = useState('');
    const [slot3, setSlot3] = useState('');
    const [notes, setNotes] = useState('');
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    const slots = useMemo(() => [slot1, slot2, slot3].filter(Boolean), [slot1, slot2, slot3]);

    const submit = async (e) => {
        e.preventDefault();
        if (!prospectId) {
            setMessage('This booking link is missing a prospect reference.');
            return;
        }
        if (!slots.length) {
            setMessage('Please add at least one preferred time slot.');
            return;
        }

        try {
            setSaving(true);
            await api.post('/coach/booking-request', {
                prospectId,
                name,
                email,
                preferredSlots: slots,
                notes,
            });
            setMessage('Thanks. Your booking request was sent to the coach.');
            setSlot1('');
            setSlot2('');
            setSlot3('');
            setNotes('');
        } catch (err) {
            setMessage(err?.response?.data?.error || 'Could not submit booking request.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '24px' }}>
            <div style={{ maxWidth: '680px', margin: '0 auto', background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '24px' }}>
                <h1 style={{ marginTop: 0, marginBottom: '8px', color: '#0f172a' }}>Request a Coaching Session</h1>
                <p style={{ marginTop: 0, color: '#475569' }}>
                    Pick a few times that work for you. Your coach will follow up with a confirmed meeting time.
                </p>

                {message && (
                    <div style={{ marginBottom: '16px', background: '#ecfeff', color: '#0f766e', border: '1px solid #a5f3fc', borderRadius: '10px', padding: '10px 12px' }}>
                        {message}
                    </div>
                )}

                <form onSubmit={submit}>
                    <label style={{ display: 'block', fontWeight: 600, marginBottom: '6px', color: '#334155' }}>Name</label>
                    <input value={name} onChange={(e) => setName(e.target.value)} style={inputStyle} placeholder="Your name" />

                    <label style={{ display: 'block', fontWeight: 600, marginBottom: '6px', marginTop: '12px', color: '#334155' }}>Email</label>
                    <input value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} placeholder="you@example.com" type="email" />

                    <label style={{ display: 'block', fontWeight: 600, marginBottom: '6px', marginTop: '12px', color: '#334155' }}>Preferred Time Slot 1</label>
                    <input value={slot1} onChange={(e) => setSlot1(e.target.value)} style={inputStyle} placeholder="Tue 10:00 AM - 10:30 AM" />

                    <label style={{ display: 'block', fontWeight: 600, marginBottom: '6px', marginTop: '12px', color: '#334155' }}>Preferred Time Slot 2 (optional)</label>
                    <input value={slot2} onChange={(e) => setSlot2(e.target.value)} style={inputStyle} placeholder="Wed 2:00 PM - 2:30 PM" />

                    <label style={{ display: 'block', fontWeight: 600, marginBottom: '6px', marginTop: '12px', color: '#334155' }}>Preferred Time Slot 3 (optional)</label>
                    <input value={slot3} onChange={(e) => setSlot3(e.target.value)} style={inputStyle} placeholder="Thu 4:00 PM - 4:30 PM" />

                    <label style={{ display: 'block', fontWeight: 600, marginBottom: '6px', marginTop: '12px', color: '#334155' }}>Notes (optional)</label>
                    <textarea value={notes} onChange={(e) => setNotes(e.target.value)} style={{ ...inputStyle, minHeight: '96px', resize: 'vertical' }} placeholder="Anything your coach should know" />

                    <button type="submit" disabled={saving} style={buttonStyle}>
                        {saving ? 'Submitting...' : 'Send Booking Request'}
                    </button>
                </form>
            </div>
        </div>
    );
}

const inputStyle = {
    width: '100%',
    border: '1px solid #cbd5e1',
    borderRadius: '10px',
    padding: '10px 12px',
    fontSize: '14px',
    boxSizing: 'border-box',
};

const buttonStyle = {
    marginTop: '16px',
    background: '#0ea5e9',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    padding: '10px 16px',
    fontWeight: 700,
    cursor: 'pointer',
};
